import { render, staticRenderFns } from "./DrillResult.vue?vue&type=template&id=f2446cd4&scoped=true&lang=pug&"
import script from "./DrillResult.vue?vue&type=script&lang=ts&"
export * from "./DrillResult.vue?vue&type=script&lang=ts&"
import style0 from "./DrillResult.vue?vue&type=style&index=0&id=f2446cd4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2446cd4",
  null
  
)

export default component.exports